import { render } from "./PolitykaPrywatnosciPage.vue?vue&type=template&id=244801bc&scoped=true"
import script from "./PolitykaPrywatnosciPage.vue?vue&type=script&lang=js"
export * from "./PolitykaPrywatnosciPage.vue?vue&type=script&lang=js"

import "./PolitykaPrywatnosciPage.vue?vue&type=style&index=0&id=244801bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244801bc"]])

export default __exports__